import analytics, { events } from '../../../shared/analytics';
import BasePage from '../../components/base-page/base-page';
import Carousel from '../../components/carousel/carousel';
import breakpoints from '../../config/breakpoints';

import './pricing-personal.scss';

export default class PricingPersonalPage extends BasePage {
  ui = {
    ctaSection: '.js-pricing-cta-section',
    testimonialsCarousel: '.js-testimonials-carousel',
    aiSwitcher: '.ai-switcher',
    pricingSwitcher: '.pricing-switcher',
    pricingCardMonthly: '[data-price-plans="monthly"]',
    pricingCardAnnual: '[data-price-plans="annual"]',
    pricingCardRegular: '[data-price-type="regular"]',
    pricingCardAi: '[data-price-type="ai"]',
  };

  events = {
    'change @ui.pricingSwitcher': 'handlePricingSwitcherToggle',
    'change @ui.aiSwitcher': 'handleAiSwitcherToggle',
  };

  onInit() {
    super.onInit();

    this.testimonialsCarousel = new Carousel({
      rootElement: this.ui.testimonialsCarousel,
      slidesPerPage: {
        [breakpoints.sm]: 2,
        [breakpoints.lg]: 3,
      },
    });

    this.testimonialsCarousel.init();

    if ('IntersectionObserver' in window) {
      this.ui.ctaSection.classList.add('pricing-personal__cta-section_shifted');
      const ctaSectionObserver = new IntersectionObserver(this.handleCtaSectionIntersection);
      ctaSectionObserver.observe(this.ui.ctaSection);
    }

    this.syncPricingCardHeaders();
    this.handleResize();

    if (document.readyState === 'complete') {
      setTimeout(() => {
        this.syncPricingCardHeaders();
      }, 0);
    } else {
      window.addEventListener('load', () => {
        setTimeout(() => {
          this.syncPricingCardHeaders();
        }, 0);
      });
    }
  }

  syncPricingCardHeaders = () => {
    if (window.innerWidth < breakpoints.xl) {
      const allHeaders = document.querySelectorAll('.pricing-card__header');
      allHeaders.forEach((header) => {
        header.style.height = 'auto';
      });

      return;
    }

    const cardRows = document.querySelectorAll('.pricing-cards:not(.pricing-cards-hidden)');

    cardRows.forEach((row) => {
      const cards = row.querySelectorAll('.pricing-card');
      if (cards.length === 0) {
        return;
      }

      cards.forEach((card) => {
        const header = card.querySelector('.pricing-card__header');
        if (header) {
          header.style.height = 'auto';
        }
      });

      let maxHeight = 0;
      cards.forEach((card) => {
        const header = card.querySelector('.pricing-card__header');
        if (header) {
          const hasSubtitle = header.querySelector('.pricing-card__subtitle') !== null;
          const height = header.offsetHeight;
          const adjustedHeight = hasSubtitle ? height + 7 : height;
          if (adjustedHeight > maxHeight) {
            maxHeight = adjustedHeight;
          }
        }
      });

      cards.forEach((card) => {
        const header = card.querySelector('.pricing-card__header');
        if (header && maxHeight > 0) {
          const hasSubtitle = header.querySelector('.pricing-card__subtitle') !== null;
          const finalHeight = hasSubtitle ? maxHeight + 7 : maxHeight;
          header.style.height = `${finalHeight}px`;
        }
      });
    });
  };

  handleResize = () => {
    let resizeTimer;
    const handleResizeEvent = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.syncPricingCardHeaders();
      }, 1);
    };

    window.addEventListener('resize', handleResizeEvent);

    this.resizeHandler = handleResizeEvent;
  };

  handleCtaSectionIntersection = (entries) => {
    entries.forEach((entry) => {
      this.ui.ctaSection.classList.toggle('pricing-personal__cta-section_shifted', !entry.isIntersecting);
    });
  };

  handlePricingSwitcherToggle = (e) => {
    if (e) {
      this.ui.pricingCardMonthly.classList.toggle('pricing-cards-hidden', e.target.checked);
      this.ui.pricingCardAnnual.classList.toggle('pricing-cards-hidden', !e.target.checked);
      const visibleRow = e.target.checked ? this.ui.pricingCardAnnual : this.ui.pricingCardMonthly;
      const headers = visibleRow.querySelectorAll('.pricing-card__header');
      headers.forEach((header) => {
        header.style.height = 'auto';
      });
      this.syncPricingCardHeaders();
    }
  };

  handleAiSwitcherToggle = (e) => {
    analytics.trackEvent(events.AI_SWITCHER_CLICK);

    if (e) {
      const regularCards = document.querySelectorAll('[data-price-type="regular"]');

      regularCards.forEach((card) => {
        card.classList.toggle('pricing-cards-hidden', e.target.checked);
      });

      const aiCards = document.querySelectorAll('[data-price-type="ai"]');
      aiCards.forEach((card) => {
        card.classList.toggle('pricing-cards-hidden', !e.target.checked);
      });

      const visibleCards = e.target.checked ? aiCards : regularCards;
      visibleCards.forEach((cardRow) => {
        const headers = cardRow.querySelectorAll('.pricing-card__header');
        headers.forEach((header) => {
          header.style.height = 'auto';
        });
      });
      this.syncPricingCardHeaders();
    }
  };

}

PricingPersonalPage.initOnDomLoaded();
